<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>未审核小区</span>
          </div>
          <div class="table-container">
            <el-table
              :data="auditCommunityManageInfo.communitys"
              border
              style="width: 100%"
            >
              <el-table-column prop="communityId" label="小区ID" width="120"></el-table-column>
              <el-table-column prop="name" label="小区名称" width="180"></el-table-column>
              <el-table-column prop="address" label="小区地址"></el-table-column>
              <el-table-column prop="nearbyLandmarks" label="附近地标" width="150"></el-table-column>
              <el-table-column prop="cityCode" label="城市编码" width="120"></el-table-column>
              <el-table-column prop="mapX" label="小区维度" width="120"></el-table-column>
              <el-table-column prop="mapY" label="小区经度" width="120"></el-table-column>
              <el-table-column prop="stateName" label="状态" width="100"></el-table-column>
              <el-table-column label="操作" width="180" align="right">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="_openAuditCommunityModal(scope.row)"
                  >审核</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="_openDeleteCommunityModal(scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="auditCommunityManageInfo.total"
              layout="total, prev, pager, next, jumper"
              style="margin-top: 20px; text-align: right;"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <delete-community ref="deleteCommunity"></delete-community>
    <audit-component ref="auditComponent"></audit-component>
  </div>
</template>

<script>
import { listCommunitys, auditCommunityState } from '@/api/auditCommunityManage/auditCommunityManageApi'
import DeleteCommunity from '@/components/common/deleteCommunity/deleteCommunity'
import AuditComponent from '@/components/common/audit/Audit'

export default {
  name: 'AuditCommunityManage',
  components: {
    DeleteCommunity,
    AuditComponent
  },
  data() {
    return {
      auditCommunityManageInfo: {
        communitys: [],
        total: 0,
        records: 1,
        currentCommunityId: ''
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listCommunitys(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listCommunitys(this.currentPage, this.pageSize)
    },
    async _listCommunitys(page, rows) {
      try {
        const params = {
          page,
          row: rows
        }
        const res = await listCommunitys(params)
        this.auditCommunityManageInfo.total = res.total
        this.auditCommunityManageInfo.records = res.records
        this.auditCommunityManageInfo.communitys = res.communitys
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAuditCommunityModal(community) {
      this.auditCommunityManageInfo.currentCommunityId = community.communityId
      this.$refs.auditComponent.open()
    },
    async _auditCommunityState(auditInfo) {
      try {
        auditInfo.communityId = this.auditCommunityManageInfo.currentCommunityId
        await auditCommunityState(auditInfo)
        this._listCommunitys(this.currentPage, this.pageSize)
      } catch (error) {
        console.error('审核失败:', error)
      }
    },
    _openDeleteCommunityModal(community) {
      this.$refs.deleteCommunity.open(community)
    }
  }
}
</script>

<style scoped>
.table-container {
  padding: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.box-card {
  margin-bottom: 20px;
}
</style>